import { APP_NAME, REGEX_EMAIL, REGEX_PHONE } from "../constants";

import { useCallback, useState } from "react";

import CardInputEmail from "../components/authentication/CardInputEmail";
import DialogInputOTP from "../components/authentication/DialogInputOTP";
import { useAppContext } from "../providers/ProviderAppContainer";
import { TEXT_SMALL } from "../style";

function buildOtpRequestBody(identifier) {
    const trimmed = String(identifier || "").trim();
    if (REGEX_EMAIL.test(trimmed)) {
        return { body: { email: trimmed.toLowerCase() } };
    }
    const digits = trimmed.replace(/\D/g, "");
    let phone = digits;
    if (phone.length === 12 && phone.startsWith("91")) {
        phone = phone.slice(2);
    } else if (phone.length === 11 && phone.startsWith("0")) {
        phone = phone.slice(1);
    }
    if (REGEX_PHONE.test(phone)) {
        return { body: { phone } };
    }
    return { error: "Enter a valid email or 10-digit phone number !" };
}

export default function Authentication() {
    const { requestAPI, showToast } = useAppContext();

    const [identifier, setIdentifier] = useState();

    const [authenticationToken, setAuthenticationToken] = useState();

    const requestOTP = useCallback(
        (setLoading, setError) => {
            const { body, error } = buildOtpRequestBody(identifier);
            if (error) {
                setError(error);
                return;
            }
            requestAPI({
                requestPath: "authentication-tokens",
                requestMethod: "POST",
                onRequestFailure: setError,
                onRequestStart: setError,
                setLoading: setLoading,
                requestPostBody: body,
                onResponseReceieved: ({ authentication_token }, responseCode) => {
                    if (responseCode === 201) {
                        setAuthenticationToken(authentication_token);
                        showToast({ severity: "success", summary: "OTP", detail: "New OTP is Sent !", life: 1000 });
                    } else {
                        setError("Failed To Generate OTP, Try Again Later !");
                        showToast({ severity: "error", summary: "OTP", detail: "Failed To Request OTP !", life: 3000 });
                    }
                },
            });
        },
        [identifier, requestAPI, showToast, setAuthenticationToken],
    );

    return (
        <div className=" flex flex-column min-h-screen bg-primary">
            <CardInputEmail identifier={identifier} setIdentifier={setIdentifier} requestOTP={requestOTP} />
            {authenticationToken && (
                <DialogInputOTP authenticationToken={authenticationToken} setAuthenticationToken={setAuthenticationToken} requestOTP={requestOTP} />
            )}
            <p className={`${TEXT_SMALL} pt-4 mb-2 w-full text-center w-full`}>{`Copyright © 2019-2025 ${APP_NAME}`} </p>
        </div>
    );
}
